import {
    VpnKey as VpnKeyIcon,
    Settings as SettingsIcon,
    Person as UserIcon,
    Security as SecurityIcon,
} from '@material-ui/icons';
import { t } from '@lingui/macro';
import { Plm } from '../../icon/Icons';
import { MenuGroup, MenuGroupItem } from '../menu';

import { AdminPages, buildRootPageTarget } from '../../pages-admin/AdminLinkUtils';
import { useIsSysAdminUser } from '../../../stores/SessionStore';

export default function PgmAdminMenu() {
    const [isSysAdminUser] = useIsSysAdminUser();
    return (
        <MenuGroup id="system" title={t`System`} expanded>
            <MenuGroupItem
                id={AdminPages.Users}
                title={t`Users`}
                icon={<UserIcon />}
                highlightChildLinks
                link={{
                    target: buildRootPageTarget(AdminPages.Users),
                }}
            />
            <MenuGroupItem
                id={AdminPages.ApiTokens}
                title={t`API Tokens`}
                icon={<VpnKeyIcon />}
                highlightChildLinks
                link={{
                    target: buildRootPageTarget(AdminPages.ApiTokens),
                }}
            />
            {isSysAdminUser && (
                <MenuGroupItem
                    id={AdminPages.Sso}
                    title={t`Authentication`}
                    icon={<SecurityIcon />}
                    highlightChildLinks
                    link={{
                        target: buildRootPageTarget(AdminPages.Sso),
                    }}
                />
            )}
            {isSysAdminUser && (
                <MenuGroupItem
                    id={AdminPages.General}
                    title={t`General`}
                    icon={<SettingsIcon />}
                    highlightChildLinks
                    link={{
                        target: buildRootPageTarget(AdminPages.General),
                    }}
                />
            )}
            {isSysAdminUser && (
                <MenuGroupItem
                    id={AdminPages.Plms}
                    title={t`Local Managers`}
                    icon={<Plm />}
                    highlightChildLinks
                    link={{
                        target: buildRootPageTarget(AdminPages.Plms),
                    }}
                />
            )}
        </MenuGroup>
    );
}
